import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import EnptReportUpload from "../../../components/EnptReportUpload/EnptReportUpload"

const EnptUploadPage = () => {
  return (
    <React.Fragment>
      <div
        className="page-content"
        style={{ maxWidth: "100%", backgroundColor: "#ffffff" }}
      >
        <MetaTags>
          <title>ENPT Reports Upload</title>
        </MetaTags>
        <div className="container-fluid" style={{ paddingRight: "35px" }}>
          <Breadcrumbs title="ENPT Reports Upload" breadcrumbItem="Reports" />
          <Container fluid>
            <EnptReportUpload />
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EnptUploadPage
